__turbopack_context__.v({
  "countryCode": "CustomDropdownGlobalWhite-module-scss-module__S_Nafq__countryCode",
  "darkBg": "CustomDropdownGlobalWhite-module-scss-module__S_Nafq__darkBg",
  "darkMode": "CustomDropdownGlobalWhite-module-scss-module__S_Nafq__darkMode",
  "darkText": "CustomDropdownGlobalWhite-module-scss-module__S_Nafq__darkText",
  "darkspecific": "CustomDropdownGlobalWhite-module-scss-module__S_Nafq__darkspecific",
  "disabled": "CustomDropdownGlobalWhite-module-scss-module__S_Nafq__disabled",
  "dropdown": "CustomDropdownGlobalWhite-module-scss-module__S_Nafq__dropdown",
  "dropdownItem": "CustomDropdownGlobalWhite-module-scss-module__S_Nafq__dropdownItem",
  "dropdownMenu": "CustomDropdownGlobalWhite-module-scss-module__S_Nafq__dropdownMenu",
  "dropdownMenuWrapper": "CustomDropdownGlobalWhite-module-scss-module__S_Nafq__dropdownMenuWrapper",
  "dropdownToggle": "CustomDropdownGlobalWhite-module-scss-module__S_Nafq__dropdownToggle",
  "liContainer": "CustomDropdownGlobalWhite-module-scss-module__S_Nafq__liContainer",
  "scrollArrow": "CustomDropdownGlobalWhite-module-scss-module__S_Nafq__scrollArrow",
  "spanWidth": "CustomDropdownGlobalWhite-module-scss-module__S_Nafq__spanWidth",
});
